import React from "react";

const fieldLabels = {
  "recipient.name": "Nazwa odbiorcy",
  "recipient.address": "Adres odbiorcy",
  "recipient.country": "Kraj odbiorcy",
  countriesOfOrigin: "Kraj pochodzenia",
  invoiceNumbers: "Numery faktur",
  packingNumbers: "Numery packing list",
  transport: "Transport",
  acid: "Numer ACID",
  grossWeight: "Łączna masa brutto (kg)",
  remarks: "Dodatkowe uwagi",
  sourcesChecked: "Sprawdzenie dokumentów",
  sap: "Kod produktu",
  hts: "HTS",
  description: "Opis towaru",
  origin: "Kraj pochodzenia",
  quantity: "Ilość",
  unit: "Jednostka",
  position: "Kolejność",
};

function formatValue(value, field, documentLabels) {
  if (value == null) return "";
  if (typeof value === "boolean") return value ? "Tak" : "Nie";
  if (field === "document") return documentLabels[value] || value;
  return String(value);
}

function ChangeBadge({ added }) {
  return (
    <span
      className={`premium-audit-badge ${added ? "premium-audit-new" : "premium-audit-old"}`}
    >
      {added ? "Dodano" : "Usunięto"}
    </span>
  );
}

function ItemChange({ change }) {
  const added = change.after != null;
  const item = added ? change.after : change.before;
  const fields = Object.entries(item).filter(
    ([, value]) => value != null && value !== "",
  );
  return (
    <details className="premium-audit-item">
      <summary className="premium-audit-row">
        <strong className="premium-audit-label">
          <i className="bi bi-chevron-right" aria-hidden="true" />
          Pozycja {change.item}
        </strong>
        <span className="premium-audit-values">
          <ChangeBadge added={added} />
          {item.sap && <span className="premium-audit-code">{item.sap}</span>}
        </span>
      </summary>
      {fields.length ? (
        <dl>
          {fields.map(([key, value]) => (
            <div key={key}>
              <dt>{fieldLabels[key] || key}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p>Brak uzupełnionych pól.</p>
      )}
    </details>
  );
}

function FieldChange({ change, documentLabels }) {
  const { field, item, document } = change;
  const label = document || fieldLabels[field] || field;
  const before = formatValue(change.before, field, documentLabels);
  const after = formatValue(change.after, field, documentLabels);
  const longText = [before, after].some(
    (value) => value.length > 72 || value.includes("\n"),
  );
  return (
    <div className="premium-audit-row">
      <strong className="premium-audit-label">
        {item ? `Pozycja ${item} · ${label}` : label}
      </strong>
      {before && after ? (
        <div
          className={`premium-audit-values${longText ? " premium-audit-text" : ""}`}
        >
          <span className="premium-audit-value premium-audit-old">
            <span
              className={longText ? "premium-audit-caption" : "visually-hidden"}
            >
              Przed zmianą:{" "}
            </span>
            {before}
          </span>
          {!longText && <i className="bi bi-arrow-right" aria-hidden="true" />}
          <span className="premium-audit-value premium-audit-new">
            <span
              className={longText ? "premium-audit-caption" : "visually-hidden"}
            >
              Po zmianie:{" "}
            </span>
            {after}
          </span>
        </div>
      ) : (
        <div className="premium-audit-values">
          <ChangeBadge added={Boolean(after)} />{" "}
          <span
            className={longText ? "premium-audit-prose" : "premium-audit-code"}
          >
            {after || before}
          </span>
        </div>
      )}
    </div>
  );
}

export default function HistoryChanges({ changes, documentLabels }) {
  return (
    <ul className="premium-audit-list" aria-label="Zmienione pola">
      {changes.map((change, index) => (
        <li key={index}>
          {change.field === "items" ? (
            <ItemChange change={change} />
          ) : (
            <FieldChange change={change} documentLabels={documentLabels} />
          )}
        </li>
      ))}
    </ul>
  );
}
